<div class="catalog-export-modal">
    <ng-template vsfDialogTitle>Download catalog</ng-template>

    <div class="catalog-export-modal__tabs" role="tablist">
        <button
            type="button"
            role="tab"
            class="catalog-export-modal__tab"
            [class.catalog-export-modal__tab--active]="activeTab === 'file'"
            [attr.aria-selected]="activeTab === 'file'"
            (click)="selectTab('file')"
        >
            File
        </button>
        <button
            type="button"
            role="tab"
            class="catalog-export-modal__tab"
            [class.catalog-export-modal__tab--active]="activeTab === 'api'"
            [attr.aria-selected]="activeTab === 'api'"
            (click)="selectTab('api')"
        >
            API
        </button>
    </div>

    <ng-container *ngIf="activeTab === 'file'">
        <section class="catalog-export-modal__section">
            <h3 class="catalog-export-modal__section-title">Catalog scope</h3>

            <label class="catalog-export-modal__option">
                <input
                    type="radio"
                    name="catalogScope"
                    value="full"
                    [(ngModel)]="scope"
                />
                <span class="catalog-export-modal__option-body">
                    <span class="catalog-export-modal__option-label">Full catalog</span>
                    <span class="catalog-export-modal__option-hint">
                        Download every product available in the catalog.
                    </span>
                </span>
            </label>

            <label
                class="catalog-export-modal__option"
                [class.catalog-export-modal__option--disabled]="!canUseFiltered"
            >
                <input
                    type="radio"
                    name="catalogScope"
                    value="filtered"
                    [(ngModel)]="scope"
                    [disabled]="!canUseFiltered"
                />
                <span class="catalog-export-modal__option-body">
                    <span class="catalog-export-modal__option-label">Filtered catalog</span>
                    <span class="catalog-export-modal__option-hint" *ngIf="canUseFiltered">
                        A total of {{ matchedCount | number }} products match the filters.
                    </span>
                    <span class="catalog-export-modal__option-hint" *ngIf="!canUseFiltered">
                        Apply filters on the listing to export a filtered catalog.
                    </span>
                </span>
            </label>

            <div
                class="catalog-export-modal__tags"
                *ngIf="scope === 'filtered' && filterTags.length > 0"
            >
                <span
                    class="catalog-export-modal__tag"
                    *ngFor="let tag of visibleFilterTags"
                    [attr.title]="tag.value"
                >
                    <span class="catalog-export-modal__tag-label" *ngIf="tag.label">
                        {{ tag.label }}:
                    </span>
                    {{ tag.value }}
                </span>
                <button
                    type="button"
                    class="catalog-export-modal__tags-toggle"
                    *ngIf="hiddenFilterTagCount > 0 || filtersExpanded"
                    (click)="toggleFilterTags()"
                >
                    {{
                        filtersExpanded
                            ? "Show less"
                            : "See " + hiddenFilterTagCount + " more"
                    }}
                </button>
            </div>
        </section>

        <section class="catalog-export-modal__section">
            <label class="catalog-export-modal__field-label" for="catalog-export-format">
                Export format
            </label>
            <select
                id="catalog-export-format"
                class="catalog-export-modal__select"
                [(ngModel)]="format"
            >
                <option *ngFor="let option of formatOptions" [ngValue]="option.value">
                    {{ option.label }}
                </option>
            </select>
        </section>

        <section class="catalog-export-modal__section">
            <label class="catalog-export-modal__option">
                <input
                    type="checkbox"
                    [(ngModel)]="includeRetailPrices"
                />
                <span class="catalog-export-modal__option-body">
                    <span class="catalog-export-modal__option-label">
                        Include Amazon retail benchmarks
                    </span>
                    <span class="catalog-export-modal__option-hint">
                        Add stored 30-day NEW prices for DE, FR, IT, ES and UK.
                    </span>
                </span>
            </label>
        </section>

        <section class="catalog-export-modal__section">
            <label class="catalog-export-modal__field-label" for="catalog-export-shipping">
                Max delivery time
            </label>
            <p class="catalog-export-modal__field-hint">
                Only include offers delivered within this timeframe:
            </p>
            <select
                id="catalog-export-shipping"
                class="catalog-export-modal__select"
                [(ngModel)]="shippingDate"
            >
                <option [ngValue]="null">No limit</option>
                <option
                    *ngFor="let option of shippingOptions"
                    [ngValue]="option.id"
                >
                    {{ option.label }}
                </option>
            </select>
        </section>

        <section class="catalog-export-modal__section">
            <label class="catalog-export-modal__field-label" for="catalog-export-mov">
                Minimum order value (MOV)
            </label>
            <p class="catalog-export-modal__field-hint">
                Only include offers with MOV up to this amount:
            </p>
            <select
                id="catalog-export-mov"
                class="catalog-export-modal__select"
                [(ngModel)]="mov"
            >
                <option [ngValue]="null">No limit</option>
                <option
                    *ngFor="let option of movOptions"
                    [ngValue]="option.value"
                >
                    {{ option.label }}
                </option>
            </select>
        </section>

        <p class="catalog-export-modal__note">
            The download contains prices, brands, GTINs and inventory for our offering.
            The catalog is downloaded according to applied filters, regional and
            traceability shopping preferences.
        </p>
    </ng-container>

    <ng-container *ngIf="activeTab === 'api'">
        <section class="catalog-export-modal__section catalog-export-modal__api">
            <h3 class="catalog-export-modal__section-title">Download catalog via API</h3>
            <p class="catalog-export-modal__api-copy">
                Clients can use our product API (free of charge) to find interesting products,
                filter on brands, categories, prices, popularity and more. Use the product API
                in conjunction with our cart API to automate your procurement process. Work
                smart and efficiently with ease!
            </p>
            <button
                type="button"
                class="catalog-export-modal__docs-link"
                (click)="openDocumentation()"
            >
                See documentation
            </button>
        </section>
    </ng-container>

    <ng-template vsfDialogButtons>
        <button
            type="button"
            class="catalog-export-modal__btn catalog-export-modal__btn--ghost"
            (click)="cancel()"
        >
            Close
        </button>
        <button
            type="button"
            class="catalog-export-modal__btn catalog-export-modal__btn--primary"
            (click)="download()"
        >
            Download
        </button>
    </ng-template>
</div>
